export default __webpack_public_path__ + "static/media/Twitter.a8401eeb.png";